<template>
  <div class="meetingReservation_week">
    <!-- 会议室预定 周 -->
    <div style="display:flex;">
        <el-form ref="meetingDay" v-loading="loading" :model="{}" style="max-width: 300px;">
        <div class="el-table el-table--fit el-table--border">
          <div class="el-table__body-wrapper">
            <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
              <tbody>
                    <tr>
                        <td class="el-table__cell tdcont tdw33" colspan="2"> <div class="header header_left"> 会议室</div></td>
                    </tr>
                    <tr v-for="(room,index) in meetPlace" :key="index">
                        <td class="el-table__cell tdcont tdw33" colspan="2"> <div class="header" style="height:45px;"> {{ room.name }}</div></td>
                    </tr>
              </tbody>
            </table>
          </div>
        </div>
      </el-form>
      <div class="meeting_day_content">
        <div class="day_left" @click="handleDayTimeChanged('left')">
            <i class="el-icon-arrow-left "></i>
        </div>
        <div class="day_right" @click="handleDayTimeChanged('right')">
            <i class="el-icon-arrow-right "></i>
        </div>
        <div ref="meetingDayLeft" class="meeting_day_right">
            <div class="day_time_list">
                <div v-for="(day,index) in meetingDay" :key="index" class="day_time_item">
                    <div class="header">{{ day.time }}</div>
                </div>
            </div>
            <div v-for="(room,index) in meetPlace" :key="index" class="day_meet_list">
                <div v-for="(time,idx) in meetingDay" :key="index+'_'+idx" class="day_room_item">
                    <div v-if="room.weekdays.length && room.weekdays[0].meetingList.length" class="room">
                        <template v-if="time.hasMeeting">
                            <div v-for="(meet, mindex) in room.weekdays[0].meetingList" :key="index+'_'+idx+'_'+mindex" class="meeting_item">
                                <el-popover placement="right" width="300" trigger="hover">
                                    <div class="meet_item_detail">
                                        <div style="margin-bottom:8px;line-height: 18px;color:#333;">{{ meet.meetSubjedt }}</div>
                                        <div style="line-height: 20px;">预约人：{{ meet.applayName }}</div>
                                        <div style="line-height: 20px;">联系方式：{{ meet.phone }}</div>
                                        <div style="line-height: 20px;">时间：{{ $moment(new Date(meet.beginTime)).format('YYYY-MM-DD HH:mm') }}-{{ $moment(new Date(meet.endTime)).format('HH:mm') }}</div>
                                        <div v-if="(meet.applayName==loginUser.personName||isAdmin)&& !$moment(meet.beginTime).isBefore($moment())" class="bnt_cancel" @click.stop="cancelMeeting(meet)">取消预约</div>
                                    </div>
                                    <div v-if="time.time == meet.tStartNum" slot="reference" class="meeting_item_todo" :style="{'width': (meet.tDiff * 1.5) + 'px', 'margin-left': (meet.tMarginLeft) * 1.5 + 'px','max-width': meet.tMaxWdith?meet.tMaxWdith+'px':'unset'}" @click.stop="rowClick(meet,room)">
                                        <div class="dv"></div>
                                        <span style="line-height: 18px;"> {{ meet.tStart }} </span>
                                    </div>
                                </el-popover>
                            </div>
                        </template>
                        <template v-else>
                            <div class="meeting_item" :style="{'cursor': $moment(new Date(time.timeStr))>=$moment(new Date())?'pointer':'default'}" @click.stop="toApplyClick(room,time.timeStr)"></div>
                        </template>
                    </div>
                    <div v-else class="room" :style="{'cursor': $moment(new Date(time.timeStr))>=$moment(new Date())?'pointer':'default'}" @click.stop="toApplyClick(room,time.timeStr)"></div>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const moment = require('moment')
export default {
    props: {

    },
    data() {
        return {
            loading: false,
            loginUser: this.$store.getters.loginUser,
            meetingDay: [], // 记录一天的时间
            meetPlace: [], // 会议室地点
            dayTime: '',
            isAdmin: false
        }
    },
    created() {
        // 是否是今天之前的日期
        this.isAdmin = this.$store.state.user.roles.includes('hygl')
        this.$bus.on('dayTimeChanged', this.dayTimeChanged)
    },
    mounted() {
    },
    beforeDestroy() {
        this.$bus.off('dayTimeChanged', this.dayTimeChanged)
    },
    methods: {
        dayTimeChanged(dayTime) {
            // this.meetingDay = week
            this.meetingDay = []
            this.dayTime = dayTime
            for (let i = 1; i < 24; i++) {
                this.meetingDay.push({
                    time: i,
                    hasMeeting: false,
                    timeStr: dayTime + ' ' + i + ':59:59'
                })
            }
            this.getMeetingRoomData(dayTime, dayTime)
            this.$nextTick(() => {
                this.$refs.meetingDayLeft.scrollLeft = this.$refs.meetingDayLeft.scrollWidth - this.$refs.meetingDayLeft.offsetWidth
                console.log('this.$refs.meetingDayLeft.scrollLeft', this.$refs)
            })
        },
        queryDataHy(arr) {
            // 查询个人某段范围内的日程
            return new Promise((resolve, reject) => {
                this.$http({
                    method: 'POST',
                    contentType: 'application/x-www-form-urlencoded',
                    data: [
                        { compare: '<=', field: 'startTime', merge: false, value: moment(arr[1]).format('YYYY-MM-DD HH:mm:ss')},
                        { compare: '>=', field: 'endTime', merge: false, value: moment(arr[0]).format('YYYY-MM-DD HH:mm:ss')},
                        { compare: 'in', field: 'status', merge: false, value: '1,2'},
                        { compare: '=', field: 'personId', merge: false, value: this.loginUser.personId},
                        { compare: '=', field: 'orgCode', merge: true, value: this.loginUser.orgCode},
                        { compare: '!=', field: 'meetPersonType', merge: true, value: 4}
                    ],
                    url: '/hygl/vwMyMeeting/querydata'
                }).then((response) => {
                    resolve(response)
                })
            })
        },
        /**
         * 该场地下的会议室信息
         */
        getMeetingRoomData(startDate, endDate, cbFunc = null) {
            var temp = {
                'body': {
                    'listdata': [
                        {
                            'approve': 1,
                            'deviceProperties': '投影仪,大屏幕,话筒',
                            'id': 'f9b06f962ede4255b08d54e4c804fdbd',
                            'layoutName': 'U型桌-长边共10人，短边共1人',
                            'meetImgname': null,
                            'meetImgurl': null,
                            'name': '12楼会议室',
                            'numPeople': 100,
                            'openday': '周一,周二,周三,周四,周五',
                            'rbegintime': '08:00',
                            'rendtime': '20:00',
                            'serviceProperties': '矿泉水,下午茶,水果',
                            'weekdays': [
                                {
                                    'meetingList': [
                                        {
                                            'agentId': null,
                                            'agentPhone': null,
                                            'agentUser': null,
                                            'applayName': '黄多',
                                            'applyUserid': 'bf7c7d7ec270483886e86edbba5b30f2',
                                            'attendDept': null,
                                            'attendLeader': null,
                                            'attendUserId': null,
                                            'attendUserName': null,
                                            'beginTime': '2025-02-06 18:10:00',
                                            'createTime': '2025-02-06 18:10:57',
                                            'departmentUser': '综合部',
                                            'deviceProperties': null,
                                            'endTime': '2025-02-06 18:50:00',
                                            'groupId': null,
                                            'id': 'c2cd21076b214967a8c150eaea9daa3a',
                                            'isParent': null,
                                            'meetDetails': '会议内容会议内容会议内容',
                                            'meetName': '12楼会议室',
                                            'meetRoomId': 'f9b06f962ede4255b08d54e4c804fdbd',
                                            'meetSubjedt': '会议主题会议主题',
                                            'numPeople': 100,
                                            'orgCode': 'tsys',
                                            'orgName': '广东易臣信息技术有限公司',
                                            'passenger': {
                                                'busiDataId': '',
                                                'status': null
                                            },
                                            'phone': '13700000009',
                                            'preordainType': '0',
                                            'remark': null,
                                            'remindType': null,
                                            'serviceProperties': null,
                                            'site': null,
                                            'status': 1,
                                            'userName': null,
                                            'week': null,
                                            'weekProperties': '周一,周二,周三,周四,周五'
                                        },
                                        {
                                            'agentId': null,
                                            'agentPhone': null,
                                            'agentUser': null,
                                            'applayName': '黄多',
                                            'applyUserid': 'bf7c7d7ec270483886e86edbba5b30f2',
                                            'attendDept': null,
                                            'attendLeader': null,
                                            'attendUserId': null,
                                            'attendUserName': null,
                                            'createTime': '2025-02-05 15:52:01',
                                            'departmentUser': '工程部',
                                            'deviceProperties': '投影仪,大屏幕,话筒',
                                            'beginTime': '2025-02-06 19:00:00',
                                            'endTime': '2025-02-07 09:45:00',
                                            'groupId': null,
                                            'id': '0d53dc9a80f04fbeb74ca5bc54d3f3bd',
                                            'isParent': null,
                                            'meetDetails': '会议内容会议内容会议内容会议内容',
                                            'meetName': '12楼会议室',
                                            'meetRoomId': 'f9b06f962ede4255b08d54e4c804fdbd',
                                            'meetSubjedt': '会议室申请20250205UPRN',
                                            'numPeople': 100,
                                            'orgCode': 'tsys',
                                            'orgName': '广东易臣信息技术有限公司',
                                            'passenger': {
                                                'busiDataId': '0d53dc9a80f04fbeb74ca5bc54d3f3bd',
                                                'status': 1
                                            },
                                            'phone': '13700000009',
                                            'preordainType': '0',
                                            'remark': '提前5分钟入场',
                                            'remindType': 0,
                                            'serviceProperties': '矿泉水,下午茶,水果',
                                            'site': '中公教育大厦',
                                            'status': 2,
                                            'userName': null,
                                            'week': '周一,周二,周三,周四,周五',
                                            'weekProperties': '周一,周二,周三,周四,周五'
                                        }
                                    ],
                                    'weekday': '2025-02-05'
                                }
                            ]
                        },
                        {
                            'approve': 0,
                            'deviceProperties': '投影仪,话筒',
                            'id': '04c5b93850c84f5cb9a8895ab3716948',
                            'layoutName': '圆型桌-8人',
                            'meetImgname': null,
                            'meetImgurl': null,
                            'name': '小会议室',
                            'numPeople': 20,
                            'openday': '周二,周三,周六,周日',
                            'rbegintime': '09:00',
                            'rendtime': '18:00',
                            'serviceProperties': '矿泉水',
                            'weekdays': [
                                {
                                    'meetingList': [
                                        {
                                            'agentId': null,
                                            'agentPhone': null,
                                            'agentUser': null,
                                            'applayName': '黄多',
                                            'applyUserid': 'bf7c7d7ec270483886e86edbba5b30f2',
                                            'attendDept': null,
                                            'attendLeader': null,
                                            'attendUserId': null,
                                            'attendUserName': null,
                                            'createTime': '2025-02-06 18:10:57',
                                            'departmentUser': '综合部',
                                            'deviceProperties': null,
                                            'beginTime': '2025-02-06 06:15:00',
                                            'endTime': '2025-02-06 09:50:00',
                                            'groupId': null,
                                            'id': 'c2cd21076b214967a8c150eaea9daa3a',
                                            'isParent': null,
                                            'meetDetails': '会议内容会议内容会议内容',
                                            'meetName': '12楼会议室',
                                            'meetRoomId': 'f9b06f962ede4255b08d54e4c804fdbd',
                                            'meetSubjedt': '会议主题会议主题',
                                            'numPeople': 100,
                                            'orgCode': 'tsys',
                                            'orgName': '广东易臣信息技术有限公司',
                                            'passenger': {
                                                'busiDataId': '',
                                                'status': null
                                            },
                                            'phone': '13700000009',
                                            'preordainType': '0',
                                            'remark': null,
                                            'remindType': null,
                                            'serviceProperties': null,
                                            'site': null,
                                            'status': 1,
                                            'userName': null,
                                            'week': null,
                                            'weekProperties': '周一,周二,周三,周四,周五'
                                        },
                                        {
                                            'agentId': null,
                                            'agentPhone': null,
                                            'agentUser': null,
                                            'applayName': '黄多',
                                            'applyUserid': 'bf7c7d7ec270483886e86edbba5b30f2',
                                            'attendDept': null,
                                            'attendLeader': null,
                                            'attendUserId': null,
                                            'attendUserName': null,
                                            'createTime': '2025-02-06 15:52:01',
                                            'departmentUser': '工程部',
                                            'deviceProperties': '投影仪,大屏幕,话筒',
                                            'beginTime': '2025-02-06 13:50:00',
                                            'endTime': '2025-02-06 15:45:00',
                                            'groupId': null,
                                            'id': '0d53dc9a80f04fbeb74ca5bc54d3f3bd',
                                            'isParent': null,
                                            'meetDetails': '会议内容会议内容会议内容会议内容',
                                            'meetName': '12楼会议室',
                                            'meetRoomId': 'f9b06f962ede4255b08d54e4c804fdbd',
                                            'meetSubjedt': '会议室申请20250205UPRN',
                                            'numPeople': 100,
                                            'orgCode': 'tsys',
                                            'orgName': '广东易臣信息技术有限公司',
                                            'passenger': {
                                                'busiDataId': '0d53dc9a80f04fbeb74ca5bc54d3f3bd',
                                                'status': 1
                                            },
                                            'phone': '13700000009',
                                            'preordainType': '0',
                                            'remark': '提前5分钟入场',
                                            'remindType': 0,
                                            'serviceProperties': '矿泉水,下午茶,水果',
                                            'site': '中公教育大厦',
                                            'status': 2,
                                            'userName': null,
                                            'week': '周一,周二,周三,周四,周五',
                                            'weekProperties': '周一,周二,周三,周四,周五'
                                        }
                                    ],
                                    'weekday': '2025-02-05'
                                }
                            ]
                        }
                    ]
                },
                'code': 'success',
                'message': '处理成功！'
            }
            this.loading = true
            const defaultEndTime = moment(new Date()).format('YYYY-MM-DD') + ' 23:59:59'
            this.$http({
                method: 'GET',
                url: 'hygl/meeting/queryMeetingRoomReserveInfo',
                contentType: 'application/x-www-form-urlencoded',
                params: {
                    startDate: startDate,
                    endDate: endDate,
                    siteId: this.$vnode.context.searchFilter.siteId
                }
            }).then((res) => {
                if (res.code === 'success') {
                    // var list = temp.body.listdata
                    var list = res.body.listdata
                    list = list.map((item) => {
                        if (item.weekdays && item.weekdays.length) {
                            if (item.weekdays[0].meetingList && item.weekdays[0].meetingList.length) {
                                item.weekdays[0].meetingList = item.weekdays[0].meetingList.map((meeting) => {
                                    meeting.tStart = moment(new Date(meeting.beginTime)).format('HH:mm')
                                    meeting.tEnd = moment(new Date(meeting.endTime)).format('HH:mm')
                                    meeting.tStartNum = moment(new Date(meeting.beginTime)).format('HH')
                                    meeting.tMarginLeft = moment(new Date(meeting.beginTime)).format('mm')
                                    meeting.tMaxWdith = moment(new Date(meeting.endTime)).format('DD') > moment(new Date(meeting.beginTime)).format('DD') ? (moment(new Date(defaultEndTime)).diff(moment(new Date(meeting.beginTime)), 'minute') + 1) * 1.5 : 0
                                    // 计算两个时间的差值
                                    meeting.tDiff = moment(new Date(meeting.endTime)).diff(moment(new Date(meeting.beginTime)), 'minute')

                                    this.meetingDay.forEach(day => {
                                        if (Number(day.time) === Number(meeting.tStartNum)) {
                                            day.hasMeeting = true
                                        }
                                    })
                                    return meeting
                                })
                            }
                        }
                        return item
                    })
                    this.meetPlace = list
                } else {
                    this.$message.error(res.message)
                }
            }).finally(() => {
                this.loading = false
            })
        },
        rowClick(row, room) {
            // approve：1 直接预定  0 申请
            console.log(row)
            const _this = this
            if (room.approve === 1) {
                const moduleInfo = {'formTemplate': 'dcontent/busiformurl?vwtype=W&url=/hygl/meeting/form.html', 'winWidth': 1000, 'delUrl': 'hygl/meeting/delete', 'addNewUrl': 'hygl/meeting/addNew', 'insertUrl': 'hygl/meeting/insert', 'moduleCode': 'meeting', 'listAdvSearchExpandPanel': 0, 'winHeight': 600, 'updateUrl': 'hygl/meeting/update', 'listDataUrl': 'hygl/meeting/listdata', 'getByIdUrl': 'hygl/meeting/getById', 'listAdvSearchAllFields': 0, 'openViewType': '0'}
                moduleInfo.room = row
                const openPage = window.open('#/mr?voId=' + row.id + '&moduleInfo=' + encodeURIComponent(JSON.stringify(moduleInfo)) + '&title=' + encodeURIComponent('会议通知') + '&moduleTitle=' + encodeURIComponent('会议管理') + '&busiInfo=' + encodeURIComponent('会议通知') + '&formUrl=hygl.meeting.form_newForm&innerUrl=&noEdit=false&canEdit=1')
                const loop = setInterval(() => {
                    if (openPage && openPage.closed) {
                        _this.$vnode.context.getSiteData()
                        clearInterval(loop)
                    }
                }, 1500)
            } else if (room.approve === 0) {
                window.open(`#/wflow?wfEngineUrl=hygl/roomApply&busiDataId=${row.id}`)
            }
        },
        // 取消预约
        cancelMeeting(meet) {
            this.$confirm('是否确认取消预订?', '操作提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http({
                    contentType: 'application/x-www-form-urlencoded',
                    url: `/hygl/meeting/cancelMeeting`,
                    method: 'PUT',
                    data: meet
                }).then(res => {
                    if (res.code === 'success') {
                        this.$message.success('处理成功。')
                        this.dayTimeChanged(this.dayTime)
                    } else {
                        this.$message.error(res.message)
                    }
                })
            })
        },
        // 预定
        toApplyClick(room, day) {
            if (this.$moment(new Date(day)) >= this.$moment(new Date())) {
                window.open(`#/wflow?wfEngineUrl=hygl/roomApply&busiCode=roomApply&wfName=会议室申请&startNodeName=&names=新增&name=${room.name}&site=${this.$vnode.context.selectedSite}&weekday=${this.dayTime}&siteId=${this.$vnode.context.searchFilter.siteId}&id=${room.id}`)
            }
        },
        handleDayTimeChanged(type) {
            // 点击使得 元素 meeting_day_right 左右滑动，且要有动画效果
            const meetingDayLeft = document.querySelector('.meeting_day_right')
            if (type === 'left') {
                meetingDayLeft.scrollLeft -= 200
            }
            if (type === 'right') {
                meetingDayLeft.scrollLeft += 200
            }
            console.log('meetingDayLeft.scrollLeft', meetingDayLeft.scrollLeft)
        }
    }
}
</script>

<style scoped lang="scss">
.meetingReservation_week {
  width: 100%;
  .el-table .el-table__cell {
    // text-align: center;
  }
  .header {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 18px;
  }
  .el-form .el-table__body td.tdw17, .el-form .el-table__body td.tdw33 {
    padding: 0;
  }

}
.today_header {
    background-color: #409eff;
    color: #fff;
}
.header_left {
    background-color: #f9f9f9;
}
.meeting_day_content {
    position: relative;
    width: calc(100% - 215px);
    border-bottom: 1px solid #e2e7ed;
    &:hover {
        .day_left,.day_right {
            display: block;
        }
    }
    .day_left {
        display: none;
        position: absolute;
        top: 1px;
        left: 0;
        height: 60px;
        line-height: 60px;
        font-size: 22px;
        color: #231f1f;
        background-color: rgba(172, 166, 166, 0.3);
        cursor: pointer;
        opacity: 0.2;
    }
    .day_right {
        display: none;
        position: absolute;
        top: 1px;
        right: 0px;
        height: 60px;
        line-height: 60px;
        font-size: 22px;
        color: #231f1f;
        background-color: rgba(172, 166, 166, 0.3);
        cursor: pointer;
        opacity: 0.2;
    }
}
.meeting_day_right {
    width: 100%;
    overflow: auto;
    transition: all 0.5s;
    &::-webkit-scrollbar-thumb {
        background-color: #d2d4da;
        border-radius: 0px;
    }

    /* 增加滚动条的宽度，高度 */
    &::-webkit-scrollbar {
        width: 0px;
        height: 0px;
    }
}
.day_time_list {
    display: flex;
    .day_time_item {
        display: inline-block;
        border-right: 1px solid #e2e7ed;
        border-top: 1px solid #e2e7ed;
        .header {
            height: 60px;
            width: 90px;
        }
    }
}
.day_meet_list {
    display: flex;
    .day_room_item {
         display: inline-block;
        border-right: 1px solid #e2e7ed;
        border-top: 1px solid #e2e7ed;
        .room {
            width: 90px;
            height: 45px;
            display: flex;
            align-items: center;
            justify-content: center;
            .meeting_item {
                width: 100%;
                height: 100%;
            }
            .meeting_item_todo {
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
                height: 100%;
                background: #1ad9a5;
                color: #fff;
                cursor: pointer;
                z-index: 1000;
                .dv {
                    width: 0;
                    height: 0;
                    border-top: 10px solid transparent;
                    border-left: 10px solid #1ad9a5;
                    background-color: #fff;
                    transform: rotate(45deg);
                    margin-right: 5px;
                }
            }
        }
    }
}
.bnt_cancel {
    display: inline-block;
    border: 1px solid #409eff;
    color: #409eff;
    padding: 4px 8px;
    margin-top: 5px;
    cursor: pointer;
}
</style>
